import React, { useEffect } from 'react';
import ScrollTop from 'libs/commons/ScrollTop';
import LayoutWrapper from 'LayoutWrapper';
import { Slide, ToastContainer } from 'react-toastify';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import NotFoundPage from 'pages/NotFoundPage';
import CssBaseline from '@mui/material/CssBaseline';
import { BottomSheet, Confirm, Modal, ModelStateProvider } from 'saladsoft-primitive';
import GlobalStyle from 'resources/styles/globalStyle';
import 'react-toastify/dist/ReactToastify.css';
import 'resources/css/Common.css';

const App = () => {
  useEffect(() => {
    if (window.location.pathname === '/') {
      window.location.href = '/title-cleansing';
    }
  }, []);
  return (
    <ModelStateProvider>
      <CssBaseline />
      <GlobalStyle />
      <BrowserRouter>
        <ScrollTop />
        <Modal />
        <Confirm />
        <BottomSheet />
        <Routes>
          <Route path="/*" element={<LayoutWrapper />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          style={{ width: '100%', maxWidth: '500px' }}
          hideProgressBar
          newestOnTop
          closeOnClick
          transition={Slide}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </BrowserRouter>
    </ModelStateProvider>
  );
};

export default App;
